import React from "react";
import instagram from "../../assets/img/icons/instagram.png";
import whatsapp from "../../assets/img/icons/whatsapp.svg";
import telegram from "../../assets/img/icons/telegram.svg";
import phone from "../../assets/img/icons/phone.svg";
import namad1 from "../../assets/img/Home/Group 101.png";
import namad2 from "../../assets/img/Home/Group 100.png";
import namad3 from "../../assets/img/Home/Group 99.png";
import arrow from "../../assets/img/icons/arrow-up.svg";
import logo from "../../assets/img/Logo/Group 95.png";
import wave from "../../assets/img/icons/Waving Hand Light Skin Tone.svg";
import Button from "../shared/Button";
const Footers = () => {
  const gotoup = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div>
      <div className="footer">
        <div className="container">
          <div onClick={gotoup} className="footer-bg-white center mb-[48px] cursor-pointer">
            <div className="font-[700] md:text-[41px] text-[16px] text-[#00A6A6] ml-[16px]">
              برگشت به بالا
            </div>
            <img width={16} className="mb-[11px]" src={arrow} />
          </div>
          <div className="footer-container">
            <div className="footer-col">
              <h4>راهنمایی</h4>
              <ul>
                <li>درباره ما بدانید</li>
                <li>قوانین وبسایت</li>
                <li>ارتباط با تیم پشتیبانی</li>
                <li>چگونگی رزرو اقامتگاه</li>
                <li>چگونگی ثبت اقامتگاه</li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>حساب کاربری</h4>
              <ul>
                <li>علاقه مندی ها</li>
                <li>ورود و ثبت نام</li>
                <li>ویرایش پروفایل</li>
                <li>اعلانات و پیام ها </li>
                <li>پیگیری شکایات</li>
                <li>ثبت اقامتگاه جدید</li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>دسته بندی ها</h4>
              <ul>
                <li>اقامتگاه تخفیف دار</li>
                <li>اقامتگاه های رزرو فوری</li>
                <li>اقامتگاه های لوکس </li>
                <li>اقامتگاه های محبوب</li>
                <li>اقامتگاه های خاص</li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>دسته بندی</h4>
              <ul>
                <li>اقامتگاه جنگلی</li>
                <li>اقامتگاه ساحلی</li>
                <li>اقامتگاه بوم گردی</li>
                <li>اقامتگاه آپارتمانی</li>
                <li>هتل و مهمان پذیر</li>
                <li>اقامتگاه ویلایی</li>
              </ul>
            </div>
            <div className="cantactus-div">
              <h4 className="font-[500] text-[32px]  text-[#292D32] mb-[28px]">
                ارتباط با ما
                <span className="font-[400] md:text-[24px] text-[16px] text-[#292D32]">
                  {" "}( هفت روز هفته ساعت ۹ الی ۱۷ )
                </span>
              </h4>
              <div className="flex justify-between">
                <div className="flex">
                  <div className="white-icon center">
                    <img src={whatsapp} />
                  </div>
                  <div className="white-icon center mx-[12px]">
                    <img src={telegram} />
                  </div>
                  <div className="white-icon center">
                    <img src={instagram} />
                  </div>
                </div>
                <div className="flex Danafont items-center">
                  {" "}<div className="font-[400] md:text-[25px] text-[20px]  text-[#12171C] ml-[10px]">
                    <span className="font-[700]  md:text-[25px]  text-[20px] text-[#12171C]">
                      {" "}093304
                    </span>37857
                  </div>
                  <img src={phone} width={23} className="mt-[-5px]" />
                </div>
              </div>
              <Button varient="primary" className="mt-[24px]" fullwidth>
                <div className="center">
                  <p > کارشناسان ما میزبان صدایتان هستند</p>
                  <img src={wave} className="mr-[5px]" />
                </div>
              </Button>
            </div>
          </div>
          <div className="footer-down">
            <div className="footer-down--namad-grid">
              <img src={namad1} className='footer-down--namad'/>
              <img src={namad2} className='footer-down--namad' />
              <img src={namad3} className='footer-down--namad' />
            </div>
            <div className="footer-down-sec">
              <p className="fonr-[400] md:text-[20px] text-[11px] text-[#797D82] mb-[16px]">
                تمامی حقوق مادی و معنوی این وبسایت متعلق به وبسایت جاتیک می باشد
              </p>
              <p className="fonr-[500] md:text-[20px] text-[13px]  text-[#292D32]">
                این یک متن نمونه می باشد و با متن اصلی جایگزین خواهد شد . این یک
                متن نمونه می باشد و با متن اصلی جایگزین خواهد شد . این یک متن
                نمونه می باشد و با متن اصلی جایگزین خواهد شد .این یک متن نمونه
                می باشد و با متن اصلی جایگزین خواهد شد .این یک متن نمونه می باشد
                و با متن اصلی جایگزین خواهد شد .
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-foot">
        <img src={logo} className="footer-foot-logo" />

        <div className="container">
          <div>
            <ul className="flex   ">
              <li>پشتیبانی</li>
              <li> قوانین </li>
              <li> پشتیبانی </li>
              <li> تماس با ما </li>
              <li> درباره ما </li>
              <li>خانه</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footers;
